import {NgModule} from '@angular/core';
import {TabsComponent} from './tabs.component';
import {TabComponent} from './tab/tab.component';
import {CommonModule} from '@angular/common';

@NgModule({
    exports: [
        TabsComponent,
        TabComponent
    ],
    imports: [
        CommonModule
    ],
    declarations: [
        TabComponent,
        TabsComponent
    ]
})
export class TabsModule { }
